import React, { Component } from 'react';
import { ContactPersonData } from '../../api/models/ContactPersonData';
import { TextField, Button, Grid, CircularProgress } from '@material-ui/core';
import PhoneNumberInput from '../../Common/PhoneNumberInput';
import EmailInput from '../../Auth/components/EmailTBox';

type Props = {
    contactPersonData: ContactPersonData
    updateContactPersonData: (cpd: ContactPersonData) => void,
    updateContactPersonDataBusy: boolean,
    updateAccountInfoSuccess: boolean | null
}

type State = {
    cpd: ContactPersonData,
    phoneNumberValid: boolean,
    isDirty: boolean
}

class ContactPersonDetails extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            cpd: JSON.parse(JSON.stringify(this.props.contactPersonData)),
            phoneNumberValid: true,
            isDirty: false
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.updateAccountInfoSuccess === null && this.props.updateAccountInfoSuccess === true)
            this.isDirty()
    }


    isDirty = () => {
        let isDirty = (this.props.contactPersonData.contactPersonName !== this.state.cpd.contactPersonName ||
            this.props.contactPersonData.contactPersonSurname !== this.state.cpd.contactPersonSurname ||
            this.props.contactPersonData.phoneNumber !== this.state.cpd.phoneNumber)
        this.setState({ isDirty })
    }

    render() {
        return (
            <Grid style={{ width: '100%', padding: "15px" }} container alignContent={"center"} alignItems={"center"} spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        onChange={(e) => this.setState({ cpd: { ...this.state.cpd, contactPersonName: e.target.value } }, () => this.isDirty())}
                        value={this.state.cpd.contactPersonName}
                        label="Contact Person Name"
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        onChange={(e) => this.setState({ cpd: { ...this.state.cpd, contactPersonSurname: e.target.value } }, () => this.isDirty())}
                        value={this.state.cpd.contactPersonSurname}
                        label="Contact Person Surname"
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <PhoneNumberInput
                        variant="standard"
                        value={this.state.cpd.phoneNumber}
                        onChange={(value: string, isValid: boolean) => { this.setState({ cpd: { ...this.state.cpd, phoneNumber: value }, phoneNumberValid: isValid }, () => this.isDirty()) }}
                        label="Phone number"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <EmailInput
                        variant="standard"
                        email={this.state.cpd.email || ""}
                        onChange={(email: string) => this.setState({ cpd: { ...this.state.cpd, email } }, () => this.isDirty())}
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <Button onClick={() => { this.props.updateContactPersonData(this.state.cpd) }}
                        disabled={!(this.state.isDirty && this.state.phoneNumberValid)} variant="contained" color="primary">Save changes</Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    {this.props.updateContactPersonDataBusy &&
                        <CircularProgress size={30} />
                    }
                </Grid>

            </Grid>
        );
    }
}

export default ContactPersonDetails;